import { Scene } from '@babylonjs/core/scene'
import { SpriteManager } from '@babylonjs/core/Sprites/spriteManager'
import { Hotspot } from '../classes/Hotspot'
import { Vector3 } from '@babylonjs/core'
import { gsap } from 'gsap'

export abstract class SpriteHelper {

  private static _spriteManager: SpriteManager
  private static _hotspots: Hotspot[] = []

  public static InitSprites(scene: Scene) {

    const spriteImage = require('../images/sprite.png');

    this._spriteManager = new SpriteManager('spriteManager', spriteImage, 5, 100, scene)
    this._spriteManager.isPickable = true;

    let hotspot1 = new Hotspot('hotspot1', this._spriteManager, 1)
    hotspot1.position = new Vector3(-1, .75, .5)

    let hotspot2 = new Hotspot('hotspot2', this._spriteManager, 2)
    hotspot2.position = new Vector3(1, .75, -.5)

    let hotspot3 = new Hotspot('hotspot3', this._spriteManager, 3)
    hotspot3.position = new Vector3(-1, .75, -.5)

    let hotspotAnimation = gsap.timeline({ repeat: -1, defaults: { stagger: .1 } });
    hotspotAnimation.to(this._spriteManager.sprites, { duration: 1, size: .45 }, 0)
      .to(this._spriteManager.sprites, { duration: 1, size: .3 }, 1.5)
  }

  public static AddHotspot(hotspot: Hotspot) {
    this._hotspots.push(hotspot)
  }

  public static GetHotspotByName(name: string) {
    return this._hotspots.find(hotspot => hotspot.sprite.name === name)
  }

  public static CleanupHotspots() {
    this._hotspots = []
  }

}